
namespace SorAraBul.Definitions {

    @Serenity.Decorators.registerClass()
    export class QuartersDialog extends Serenity.EntityDialog<QuartersRow, any> {
        protected getFormKey() { return QuartersForm.formKey; }
        protected getIdProperty() { return QuartersRow.idProperty; }
        protected getLocalTextPrefix() { return QuartersRow.localTextPrefix; }
        protected getNameProperty() { return QuartersRow.nameProperty; }
        protected getService() { return QuartersService.baseUrl; }
        protected getDeletePermission() { return QuartersRow.deletePermission; }
        protected getInsertPermission() { return QuartersRow.insertPermission; }
        protected getUpdatePermission() { return QuartersRow.updatePermission; }

        protected form = new QuartersForm(this.idPrefix);

        constructor() {
            super();
            SorAraBul.Common.preventAutofill([
                this.form.CountryId,
                this.form.IlceCityId,
                this.form.IlceId
            ]);
        }
    }
}
